import { useId } from 'react';
import { cx } from './cx';

// Two bookmarks whose points make a W. The right one is drawn last; the left
// one is masked clear of it, so the gap between them reads on any ground.
const LEFT = 'M8 4H24V32L16 43L8 32Z';
const RIGHT = 'M22 4H38V32L30 43L22 32Z';

/**
 * The mark. On its own it sits on the chrome in the logo colours; as a tile
 * it's the app icon: the pair in on-accent, on an accent square.
 */
export function Mark({ tile, className }: { tile?: boolean; className?: string }) {
  const cut = useId();
  return (
    <svg
      className={cx('mark', tile && 'mark-tile', className)}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      {tile ? <rect className="mk-tile" width="48" height="48" rx="11" /> : null}
      <g transform={tile ? 'translate(8.9 8.5) scale(0.66)' : undefined}>
        <mask id={cut} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
          <rect width="48" height="48" fill="white" />
          <path d={RIGHT} fill="black" stroke="black" strokeWidth={tile ? 3.6 : 2.4} />
        </mask>
        <path className="mk-a" d={LEFT} mask={`url(#${cut})`} />
        <path className="mk-b" d={RIGHT} />
      </g>
    </svg>
  );
}

/** The lockup in the top bar: the mark and the name, lowercase, always. */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={cx('logo', className)}>
      <Mark />
      <span className="logo-word">wellread</span>
    </span>
  );
}
